import { useEffect, useState } from "react";
import { MdArrowForward, MdEmail, MdPhone } from "react-icons/md";
import { getInlineLoader } from "../Helpers";
import productShowcase from "../assets/plack2.png";
import Footer from "../ones/Footer";
import ContactUsContent from "../ones/ContactUsContent";

export default function View(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <section className="contact-page-hero">
        <div className="container">
          <div className="contact-page-hero-inner">
            <div className="contact-page-hero-copy" data-aos="fade-up">
              <p className="home-banner-kicker">Contact Esmeriser</p>
              <h1 className="contact-page-title font-bold">
                Let&apos;s Shape Your Next Printed Product.
              </h1>
              <p className="contact-page-lead">
                Tell us what you want to print, brand, package, or promote. We
                will help turn your idea into a clean, memorable finished piece.
              </p>

              <div className="contact-page-hero-actions">
                <a href="tel:+255717515036" className="contact-page-hero-btn">
                  <MdPhone size={20} />
                  Call Us
                </a>
                <a
                  href="mailto:info@esmeriser.co.tz"
                  className="contact-page-hero-btn contact-page-hero-btn-light"
                >
                  <MdEmail size={20} />
                  Email Us
                  <MdArrowForward size={18} />
                </a>
              </div>
            </div>

            <img
              src={productShowcase}
              alt="Esmeriser branded print products"
              className="contact-page-hero-img"
              data-aos="fade-left"
            />
          </div>
        </div>
      </section>

      <ContactUsContent showHeader={false} />
      <Footer />
    </>
  );
}
